// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard';
export const DRAWER_WIDTH = 220;
export const MINI_DRAWER_WIDTH = 56;
/** Viewports at or below this width use mini sidebar; expanded sidebar from 1225px up (e.g. 1440px). */
export const DRAWER_COMPACT_MAX_WIDTH = 1224;


const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
